// extracted by css-extract-rspack-plugin
export default {"bulkActions":"Qu_y4"};